import { HttpError, useOne } from '@refinedev/core';

type MeetingNote = {
  markdownContent: string;
  templatisedFileId: number;
};

type UseCalendarEventMeetingNoteResult = {
  meetingNote: MeetingNote | undefined;
  isLoading: boolean;
  isError: boolean;
  error: HttpError | null;
  refetch: () => void;
};

export const useCalendarEventMeetingNote = (
  eventId: string,
  { enabled }: { enabled: boolean },
): UseCalendarEventMeetingNoteResult => {
  const { data, isLoading, isError, error, refetch } = useOne<MeetingNote>({
    resource: `calendar-events/${eventId}/meeting-notes`,
    id: '',
    queryOptions: {
      enabled,
    },
  });

  return {
    meetingNote: data?.data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
